export default __webpack_public_path__ + "static/media/cvm@2x.99119ae2.png";